import { api } from '../assets/config/api.config';

export const environment = {
  production: false,
  apiUrl: api.dev,
  name: 'development',
  sentryDsn: '',
  isLocal: false
};
